module.exports = __webpack_public_path__ + "img/madmimi.5bd58860.png";